import React, { useEffect, useRef } from "react";
import * as styles from "./inpostGeowidget.module.css";
const GEOWIDGET_CSS = "https://geowidget.inpost.pl/inpost-geowidget.css";
const GEOWIDGET_JS = "https://geowidget.inpost.pl/inpost-geowidget.js";
/**
 * Injects an external asset into <head> once, guarding against duplicate injection.
 * Mirrors the dynamic asset-loading pattern used in `scripts/useStyle.ts`.
 */
function loadAssetOnce(tag, attributes) {
    const matchAttr = tag === "link" ? "href" : "src";
    const selector = `${tag}[${matchAttr}="${attributes[matchAttr]}"]`;
    if (document.head.querySelector(selector))
        return;
    const element = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    document.head.appendChild(element);
}
/**
 * Renders the InPost Geowidget so the customer can pick a parcel locker. The widget is a
 * web component defined by an external script; we mount it imperatively and receive the
 * selected point through a uniquely named global callback (the `onpoint` attribute).
 */
export default function InpostGeowidget(props) {
    const containerRef = useRef(null);
    const callbackName = useRef(`inpostOnPoint_${Math.random().toString(36).slice(2)}`);
    const onSelectRef = useRef(props.onSelect);
    useEffect(() => {
        onSelectRef.current = props.onSelect;
    });
    useEffect(() => {
        if (!props.token)
            return () => { };
        loadAssetOnce("link", { rel: "stylesheet", href: GEOWIDGET_CSS });
        loadAssetOnce("script", { src: GEOWIDGET_JS, defer: "true" });
        window[callbackName.current] = (point) => {
            var _a, _b, _c, _d, _e;
            const line1 = (_b = (_a = point === null || point === void 0 ? void 0 : point.address) === null || _a === void 0 ? void 0 : _a.line1) !== null && _b !== void 0 ? _b : "";
            const line2 = (_d = (_c = point === null || point === void 0 ? void 0 : point.address) === null || _c === void 0 ? void 0 : _c.line2) !== null && _d !== void 0 ? _d : "";
            const address = [line1, line2].filter(Boolean).join(", ");
            onSelectRef.current({ name: (_e = point === null || point === void 0 ? void 0 : point.name) !== null && _e !== void 0 ? _e : "", address });
        };
        const widget = document.createElement("inpost-geowidget");
        widget.setAttribute("token", props.token);
        widget.setAttribute("language", "pl");
        widget.setAttribute("config", "parcelCollect");
        widget.setAttribute("onpoint", callbackName.current);
        const container = containerRef.current;
        container === null || container === void 0 ? void 0 : container.appendChild(widget);
        return () => {
            if (container === null || container === void 0 ? void 0 : container.contains(widget))
                container.removeChild(widget);
            delete window[callbackName.current];
        };
    }, [props.token]);
    if (!props.token) {
        return (React.createElement("div", { className: styles.placeholder }, "Wyb\u00F3r paczkomatu jest chwilowo niedost\u0119pny."));
    }
    return React.createElement("div", { ref: containerRef, className: styles.mount });
}
